export default "__VITE_ASSET__WMhOoz$m__"